import type { ReactNode } from "react";

export const GuideChecks = ({
  checks,
  problem,
}: {
  checks: ReactNode[];
  problem: { title: string; body: ReactNode };
}) => (
  <section aria-labelledby="guide-checks">
    <h2 id="guide-checks">Before you move on</h2>
    <ul className="marker:text-success">
      {checks.map((check, index) => (
        <li key={index}>{check}</li>
      ))}
    </ul>
    <details className="border-y border-line py-4">
      <summary>{problem.title}</summary>
      <p>{problem.body}</p>
    </details>
  </section>
);
